import EmojiRegex from 'emoji-regex'
import { PING_EVERYONE, PING_MODS } from '@/utils/constants/chat'

export const CHAT_EMOJI_UNICODES = EmojiRegex().source.replace(/\/|g/g, '')
export const CHAT_EMOTE = ':[A-z0-9-_]{2,48}:'
export const CHAT_MENTION = `@.{2,32}#[0-9]{3,12}|@\\b(?:${PING_EVERYONE}|${PING_MODS})\\b`

export const CHAT_AC_EMOTE = `${CHAT_EMOTE.slice(0, -1)}$`
export const CHAT_AC_MENTION = '@[A-z0-9-._#]{2,32}$'

export const URL_RE = '[(http(s)?)://(www.)?A-Za-z0-9@:%._+~#=]{2,256}\\.[a-z]{2,6}\\b(?:[-a-zA-Z0-9@:%_+.~#?&/=]*)'
export const TRADEURL_RE = /^https?:\/\/(?:www.)?steamcommunity\.com\/tradeoffer\/new\/?\?partner=(\d+)(?:&|&amp;)token=([a-z0-9-_]{8})/i
export const STEAMKEY_RE = /^[A-F0-9]{32}$/
export const EMAIL_RE = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
export const ALPHANUM_RE = /^[a-zA-Z0-9_]*$/
